export default __webpack_public_path__ + "static/media/white_wine.10cdc096.jpg";